import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="bg-white shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center" onClick={closeMenu}>
              <span className="text-2xl font-bold text-primary-600">ContractGuard</span>
            </Link>
          </div>

          {/* Desktop nav */}
          <div className="hidden sm:flex items-center space-x-4">
            {user ? (
              <>
                <Link to="/dashboard" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Dashboard</Link>
                <Link to="/upload" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Upload</Link>
                <Link to="/account" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Account</Link>
                <Link to="/pricing" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Pricing</Link>
                <button onClick={handleLogout} className="bg-gray-200 text-gray-700 hover:bg-gray-300 px-4 py-2 rounded-md font-medium">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/pricing" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Pricing</Link>
                <Link to="/login" className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md font-medium">Login</Link>
                <Link to="/signup" className="bg-primary-600 text-white hover:bg-primary-700 px-4 py-2 rounded-md font-medium">Sign Up</Link>
              </>
            )}
          </div>

          {/* Mobile hamburger button */}
          <div className="flex items-center sm:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-gray-700 hover:text-primary-600 p-2 rounded-md"
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile dropdown menu */}
        {menuOpen && (
          <div className="sm:hidden border-t border-gray-100 py-2">
            {user ? (
              <>
                <Link to="/dashboard" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Dashboard</Link>
                <Link to="/upload" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Upload Contract</Link>
                <Link to="/account" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Account</Link>
                <Link to="/pricing" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Pricing</Link>
                <button onClick={handleLogout} className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/pricing" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Pricing</Link>
                <Link to="/login" onClick={closeMenu} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium">Login</Link>
                <Link to="/signup" onClick={closeMenu} className="block mx-4 my-2 text-center bg-primary-600 text-white hover:bg-primary-700 px-4 py-2 rounded-md font-medium">Sign Up</Link>
              </>
            )}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
